import languageParser from 'accept-language-parser';

import { getFunlidayCookie } from './funlidayCookie';
import { systemLanguageCode } from './locale_util';

export const acceptLanguageToLanguage = acceptLanguage => {
  const lowerCaseLanguages = acceptLanguage.toLowerCase();
  const languages = languageParser.parse(lowerCaseLanguages);

  const newLanguages = {};

  for (let i = 0; i < languages.length; i++) {
    const obj = languages[i];
    const key = obj.code + (obj.region ? `-${obj.region}` : '');

    newLanguages[key] = obj.quality;
  }

  if (
    lowerCaseLanguages.indexOf('zh-cn') > -1 ||
    lowerCaseLanguages.indexOf('zh-hans') > -1
  ) {
    const twQuality = newLanguages['zh-tw'];
    const cnQuality = newLanguages['zh-cn'];
    if (!twQuality) {
      return 'zh-cn';
    }

    if (twQuality && cnQuality > twQuality) {
      return 'zh-cn';
    }
  }

  if (
    lowerCaseLanguages.indexOf('zh-tw') > -1 ||
    lowerCaseLanguages.indexOf('zh') > -1
  ) {
    return 'zh-tw';
  }

  if (lowerCaseLanguages.indexOf('zh-hk') > -1) {
    return 'zh-hk';
  }

  if (lowerCaseLanguages.indexOf('ja') > -1) {
    return 'ja';
  }

  if (lowerCaseLanguages.indexOf('ko') > -1) {
    return 'ko';
  }

  return lowerCaseLanguages.split(',')[0];
};

export const handleTWLanguage = language => {
  if (
    language === 'zh-TW' ||
    language === 'zh-tw' ||
    language === 'zh_tw' ||
    language === 'zh_TW' ||
    language === 'zh'
  ) {
    return 'zh-tw';
  }
  return language || 'zh-tw';
};

/** getLanguageByRank 取得對應的 language 以利組多國語系 meta-tag
 * @param {string} hlQuery 帶在網址 ?hl= 的語系
 * @param {string} authorLanguage 該頁面內容作者的語系
 * @param {string} acceptLanguage 頁面瀏覽者的語系
 * @description 在 journals、articles、collections、itinerary 的 meta-tag 顯示語系先後順序：1. 一定是先看網址是否有 ?hl= 帶語系 2. 看瀏覽器使用者 accept language 語系 3. 若是爬蟲之類 bot 沒 acceptLanguage 才看內容作者自己的 language
 * @returns {string} language 語系
 */
export const getLanguageByRank = (hlQuery, authorLanguage, acceptLanguage) => {
  console.log({ hlQuery, authorLanguage, acceptLanguage });
  if (hlQuery) {
    const hlList = ['ko', 'zh-tw', 'en', 'ja', 'zh-cn'];
    const isMatch = hlList.some(item => hlQuery === item);
    if (isMatch) return hlQuery;
  }
  if (acceptLanguage) {
    return acceptLanguageToLanguage(acceptLanguage);
  }
  return handleTWLanguage(authorLanguage);
};

export const getLanguageAsAreaID = language => {
  if (
    language === 'zh' ||
    language.indexOf('tw') > -1 ||
    language.indexOf('TW') > -1
  ) {
    return language;
  }
  return language;
};

export const stringifyLanguages = () => {
  if (navigator && navigator.language) {
    try {
      return navigator.languages.reduce(
        (acc, cur, index) => (index === 0 ? cur : `${acc},${cur}`),
        ''
      );
    } catch (error) {
      return '';
    }
  }
  return '';
};

export const getLanguageCookie = () =>
  getFunlidayCookie('language') || systemLanguageCode();
